module.exports = function() {
  return new Worker("/" + "ColorExtractor.worker.js");
};